import Vue from 'vue';

export function updateAuthStatus(state, value) {
  Vue.set(state.status, 'authenticated', value);
}

export function updateUsers(state, value) {
  state.users = value;
}

export function updateAuthUser(state, value) {
  state.authUser = value;
}

export function updateStatus(state, value) {
  Vue.set(state.status, 'loading', value);
}
export function updateUser(state, value) {
  Vue.set(state, 'user', value);
}
export function updateLoginError(state, value) {
  state.loginError = value;
}
export function updateRegistrationError(state, value) {
  state.registrationError = value;
}
